import React from 'react'

const LoginContext = React.createContext({
    isLoggedIn: false,
    setIsLoggedIn: () => {}
})

const useLogin = () => React.useContext(LoginContext)

export {LoginContext, useLogin}